import { CDC_APIKEY, CDC_APIKEY_IDP } from "../constants/api-constants"
import axios from "axios"
import Cookies from "universal-cookie"
import { isTokenExpired } from "../utils/validateToken"
import { GetUnlogedToken, GetLogedToken } from "./refreshToken"
export const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error) {
      const originalRequest = error.config

      if (error.response) {
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true
          try {
            refreshAccessToken(originalRequest)
          } catch (error) {
            if (error.response && error.response.data) {
              return Promise.reject(error.response.data)
            } else {
              return Promise.reject(error)
            }
          }
        }
        if (error.response.status === 403 && error.response.data) {
          // Unauthorized request: maybe access token has expired!
          try {
            return refreshAccessToken(originalRequest)
          } catch (error) {
            return Promise.reject(error)
          }
        }
      }
    }
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.request.use(
  async (config) => {
    const cookies = new Cookies()
    const token = cookies.get("token")
    const uid = cookies.get("uid-r")

    if (token && isTokenExpired(token) === false) {
      const url = config.url.includes("amazonaws")
      if (url) {
        config.headers.Authorization = token
        return config
      } else {
        config.headers.Authorization = "Bearer " + token
        return config
      }
    }
    if (token && isTokenExpired(token) === true) {
      if (uid) {
        try {
          const newToken = await GetLogedToken(uid)
          const url = config.url.includes("amazonaws")
          cookies.remove("token")
          cookies.set("token", newToken)
          if (url) {
            config.headers.Authorization = newToken
            return config
          } else {
            config.headers.Authorization = "Bearer " + newToken
            return config
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        try {
          const neeTok = await GetUnlogedToken()
          const url = config.url.includes("amazonaws")
          cookies.remove("token")
          cookies.set("token", neeTok)
          if (url) {
            config.headers.Authorization = neeTok
            return config
          } else {
            config.headers.Authorization = "Bearer " + neeTok
            return config
          }
        } catch (error) {
          console.log(error)
        }
      }
    }

    if (!token) {
      if (uid) {
        try {
          const newToken = await GetLogedToken(uid)
          const url = config.url.includes("amazonaws")
          cookies.remove("token")
          cookies.set("token", newToken)
          if (url) {
            config.headers.Authorization = newToken
            return config
          } else {
            config.headers.Authorization = "Bearer " + newToken
            return config
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        try {
          const neeTok = await GetUnlogedToken()
          const url = config.url.includes("amazonaws")
          cookies.remove("token", { path: "/" })
          cookies.set("token", neeTok)
          if (url) {
            config.headers.Authorization = neeTok
            return config
          } else {
            config.headers.Authorization = "Bearer " + neeTok
            return config
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  (error) => {
    Promise.reject(error)
  },
)

const refreshAccessToken = (_originalRequest) => {
  try {
    _originalRequest._retry = true
    getToken(_originalRequest)
  } catch (error) {
    console.log(error)
  }
}

const getToken = (_originalRequest) => {
  try {
    const cookies = new Cookies()
    const uid = cookies.get("uid-r")
    if (uid) {
      axios
        .get(
          `${process.env.CATEGORY_API_URL}/comfama/tokenizer/api/v1/accessToken?uid=${uid}`,
        )
        .then((data) => {
          if (data.status === 200) {
            _originalRequest.headers.Authorization = data.data.data.accessToken
            return axios(_originalRequest)
          }
        })
    } else {
      const config = {
        headers: {
          apikey: CDC_APIKEY,
        },
      }

      if (process.env.ENVIRONMENT !== "PDN") {
        config.headers.origin = "https://internetpruebas.comfama.intranet"
      }
      const data = {
        action: "getJWT",
      }

      const url = process.env.URL_CDC
      axios
        .post(`${url}`, data, config)
        .then((res) => {
          const dataUser = {
            documentNumber: 99999999,
            documentType: "C01C",
          }
          const url = process.env.URL_CDC_IDP_UNLOGIN
          const config = {
            headers: {
              apikey: CDC_APIKEY_IDP,
              authorization: `Bearer ${res.data.data.id_token}`,
            },
          }

          axios.post(`${url}`, dataUser, config).then((res) => {
            if (res.status === 200) {
              cookies.remove("token")
              cookies.set("token", res.data.data)
              _originalRequest.headers.Authorization = res.data.data
              return axios(_originalRequest)
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  } catch (error) {
    console.log(error)
  }
}
